// The task groups list and one group's page.
import { plural } from "../../../helpers";

const p = plural("en");

export default {
  filterByStatus: "Filter by status",
  source: "Source",
  allSources: "All sources",
  allTaskTypes: "All task types",
  everyone: "Everyone",
  listFailed: "Could not load the task groups",
  mine: "Your task groups, their tasks and where each one is in its workflow",
  noGroups: "No task groups yet",
  noGroupsBody: "A task group is a task type, where its tasks come from and a workflow from the marketplace. Create one here or in the apps.",
  nothingMatches: "Nothing matches",
  nothingMatchesBody: "No task group matches these filters.",
  tableLabel: "Task groups",
  noTasks: "No tasks",
  tasksWord: (n: number) => p(n, { one: " task", other: " tasks" }),
  activeCount: (n: number) => ` · ${n} active`,
  countsLabel: (total: number, words: string) => `${p(total, { one: "# task", other: "# tasks" })}: ${words}`,
  notYet: "Not yet",
  title: "Task group",
  loadFailed: "Could not load the task group",
  ownedBy: (owner: string) => `Owned by ${owner}. Read-only here: the owner changes it from their devices.`,
  tasksDescription: "Newest activity first",
  noTasksYet: "No tasks yet",
  noTasksManual: "The owner adds tasks from the app.",
  noTasksPolled: "New issues that match the source's filter become tasks when the group is polled.",
  lastPollFailed: "The last poll failed",
  factsLabel: "Task group facts",
  isolation: "Isolation",
  refresh: "Refresh",
  polled: (ago: string) => `last ${ago}`,
  notPolled: "not polled yet",
  repositories: "Repositories",
  sourceOwn: "The source's own",
  parallel: "Parallel tasks",
  environment: "Environment",
  notAssigned: "Not yet assigned",
  created: "Created",
  costs: "Costs",
  costsDescription: "Finished agent steps, all time · API-equivalent price",
  steps: (n: number) => p(n, { one: "# step", other: "# steps" }),
  tokens: "tokens",
  canStart: "Tasks can start",
  blocked: "Blocked",
  noRequirements: "No requirements",
  noRequirementsBody: "The workflow needs no secrets and runs in a container.",
  cursorSoon: "Coming soon: Cursor runs are refused for now",
  credential: (id: string) => `credential ${id}`,
  requirements: "Requirements",
  requirementsDescription: "Bindings to the owner's secrets, checked now",
  subTasks: (n: number) => p(n, { one: "# sub-task", other: "# sub-tasks" }),
  showSubTasks: (n: number, title: string) => `Show ${p(n, { one: "# sub-task", other: "# sub-tasks" })} of ${title}`,
  hideSubTasks: (n: number, title: string) => `Hide ${p(n, { one: "# sub-task", other: "# sub-tasks" })} of ${title}`,
  toolbar: {
    label: "Task group actions",
    hideDetails: "Hide details",
    showDetails: "Show details",
    refresh: "Refresh tasks now",
    refreshHint: "Check the source for new and closed issues without waiting for the next poll",
    refreshPaused: "Resume the group to refresh its tasks",
    refreshed: "Tasks refreshed from the source",
    refreshFailed: "The source could not be read: see the error above",
    vpnHint: "Open the VPN settings",
    network: "Network activity",
    networkHint: "The domains the group's agents reached or were refused",
  },
  shared: {
    title: "Shared files",
    description: "Files you put in the VM that the agents can read",
    vmPath: "Put files in the VM at",
    agentPath: "Agents read them, read-only, at",
    empty: "No shared files yet",
    emptyBody: "Copy files into the VM folder from the VM terminal; agents see them at once. Docker image tars go in images/, and agents load one when a step needs it.",
    openTerminal: "Open the VM terminal",
    stopped: "Start the environment to see its shared files. The VM starts with the group's next task.",
    truncated: "Only the first 500 entries are shown.",
    folder: "folder",
  },
  actions: {
    edit: "Edit",
    pause: "Pause",
    resume: "Resume",
    archive: "Archive",
    paused: "Task group paused: no new tasks start until you resume it",
    resumed: "Task group resumed",
    archived: (name: string) => `Task group “${name}” archived`,
    archiveConfirm: (name: string) => `Archive “${name}”?`,
    archiveBody: "The group stops for good: its source is no longer checked and its queued tasks are cancelled. Tasks already running finish their current step. This cannot be undone.",
  },
};
